import React, { useState, useEffect } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import "./MonthPicker.css";

const CalendarIcon = FaCalendarAlt as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

interface MonthPickerProps {
  onChange: (range: { startDate: Date; endDate: Date }) => void;
  value: Date; // still useful to highlight active month
}

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const MonthPicker: React.FC<MonthPickerProps> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [year, setYear] = useState(value.getFullYear());

  // 🔹 Automatically send current month range on mount or when `value` changes
  //   useEffect(() => {
  //     const startDate = new Date(
  //       value.getFullYear(),
  //       value.getMonth(),
  //       1,
  //       0,
  //       0,
  //       0
  //     );
  //     const endDate = new Date(
  //       value.getFullYear(),
  //       value.getMonth() + 1,
  //       0,
  //       23,
  //       59,
  //       59
  //     );
  //     onChange({ startDate, endDate });
  //   }, [value, onChange]);

  const handleMonthClick = (monthIndex: number) => {
    const startDate = new Date(year, monthIndex, 1, 0, 0, 0);
    const endDate = new Date(year, monthIndex + 1, 0, 23, 59, 59);

    onChange({ startDate, endDate });
    setOpen(false);
  };

  return (
    <div className="month-picker">
      <button className="month-picker-trigger" onClick={() => setOpen(!open)}>
        <CalendarIcon className="month-picker-icon" />
        {months[value.getMonth()]} {value.getFullYear()}
        <span className="month-picker-arrow">▾</span>
      </button>

      {open && (
        <div className="month-picker-dropdown">
          <div className="month-picker-year">
            <button onClick={() => setYear(year - 1)}>◀</button>
            <span>{year}</span>
            <button onClick={() => setYear(year + 1)}>▶</button>
          </div>
          <div className="month-picker-grid">
            {months.map((m, idx) => (
              <div
                key={m}
                className={`month-picker-option ${
                  idx === value.getMonth() && year === value.getFullYear()
                    ? "active"
                    : ""
                }`}
                onClick={() => handleMonthClick(idx)}
              >
                {m} {year}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MonthPicker;
